// i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from './translations/ar/global.json';
import he from './translations/he/global.json';

const savedLng = localStorage.getItem('lng') || 'ar';   // 👈 remember user choice

i18n
    .use(initReactI18next)
    .init({
        resources: {
            ar: { global: ar },
            he: { global: he },
        },
        lng: savedLng,
        fallbackLng: 'ar',
        interpolation: { escapeValue: false },
    });

export default i18n;
